module.exports = __webpack_public_path__ + "main/assets/fonts/scoville/scoville.woff2";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/scoville/scoville.woff2
// module id = 1283
// module chunks = 0